import React, { type Dispatch, type SetStateAction } from "react";

import { useAuthState } from "@synthesis/shared-auth";
import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";

import { useStores } from "../../../store";

interface AddModalDeleteFileProps {
  deleteId?: string;
}

interface ModalDeleteFileProps extends AddModalDeleteFileProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

const ModalDeleteFile = React.memo((props: ModalDeleteFileProps) => {
  const { deleteId } = props;
  return (
    <Modal.Root manual {...props}>
      <AddModalDeleteFile deleteId={deleteId} />
    </Modal.Root>
  );
});

const AddModalDeleteFile = React.memo(({ deleteId }: AddModalDeleteFileProps) => {
  const { fileStore, generalStore } = useStores();
  const authStore = useAuthState();
  const { closeModal } = useManualModalState();

  const handleConfirm = () => {
    const userId = authStore.currentUser?.id;
    if (!userId) return;

    if (generalStore.checkedFiles.size > 1) {
      generalStore.deleteCheckedContents(userId);
    } else {
      if (deleteId) {
        fileStore.deleteFile(deleteId, userId);
      }
    }
    closeModal();
  };

  const title = `Удаление ${generalStore.checkedFiles.size > 1 ? "нескольких файлов" : "файла"}`;

  return (
    <Modal.Content className="w-[35vw] min-w-[350px]">
      <Modal.Title>{title}</Modal.Title>
      <div className="px-5 pb-2">
        <h2 data-cy="modalDeleteFile-h2-projectDocks" className="mt-2">
          Вы уверены, что хотите безвозвратно удалить {generalStore.checkedFiles.size > 1 ? "выбранные файлы?" : "этот файл? "}
        </h2>
        <div className="my-2 flex content-center justify-between">
          <Button data-cy="modalDeleteFile-button" type="button" theme="primary" onClick={handleConfirm}>
            Удалить {generalStore.checkedFiles.size > 1 ? "файлы?" : "файл? "}
          </Button>
          <Button data-cy="modalDeleteFile-button" type="button" onClick={() => closeModal()}>
            Отменить
          </Button>
        </div>
      </div>
    </Modal.Content>
  );
});

export default ModalDeleteFile;
